export const PRINT_CUSTOMIZABLE_PDF = 'PRINT_CUSTOMIZABLE_PDF';
export const PRINT_PDF_LOADING = 'PRINT_PDF_LOADING';
export const PRINT_PDF_FOR_TEXT = 'PRINT_PDF_FOR_TEXT';
export const PRINT_PDF_FOR_EMAIL = 'PRINT_PDF_FOR_EMAIL';
export const SET_PDF_URL_FOR_SHARING = 'SET_PDF_URL_FOR_SHARING';
export const CLEAR_PDF_URL_FOR_SHARING = 'CLEAR_PDF_URL_FOR_SHARING';
export const PREPARE_SHARING_CONTENT = 'PREPARE_SHARING_CONTENT';
export const CLEAR_SHARING_CONTENT = 'CLEAR_SHARING_CONTENT';
export const PRINT_PDF_RESET_SUCCESS = 'PRINT_PDF_RESET_SUCCESS';
export const PRINT_PDF_SUCCESS = 'PRINT_PDF_SUCCESS';
export const PUBLISH_TO_SHOWROOM = 'PUBLISH_TO_SHOWROOM';
export const GENERATE_PDF = 'GENERATE_PDF';
